import { ErrorObject } from '@thoughtspot/blink-context';
import { translate as t } from '@thoughtspot/i18n';
import { AnswerJoinPathAmbiguityErrorType } from '/@services/generated/graphql-types';
import { ApolloError } from '../../utils/error-handling/apollo-hooks-wrappers/custom-apollo-hooks';

// ErrorType from Prism to Message Code mappings
export const AnswerErrorTypeToMsgCodeMappings = {
    [AnswerJoinPathAmbiguityErrorType.JoinPathResolutionRequired]: '13076',
};

const PRIVILEGE_DATA_ERROR_CODE = '10003';
const COLUMN_LEVEL_ACCESS_RESTRICTED_ERROR_CODE = '13059';

export const getJoinPathAmbiguityErrorMsg = () =>
    `msg_code.${
        AnswerErrorTypeToMsgCodeMappings[
            AnswerJoinPathAmbiguityErrorType.JoinPathResolutionRequired
        ]
    }.summary`;

export const hasJoinPathAmbiguityErrorType = (error: ErrorObject[]) =>
    error?.[0]?.code ===
    AnswerJoinPathAmbiguityErrorType.JoinPathResolutionRequired;

// check if the ApolloError has JoinPathResolutionRequired error type
export const shouldRemapToJoinPathAmbiguityError = (
    error: ApolloError,
): boolean => {
    const errObj = (error?.networkError as any)?.result?.errors?.[0];
    return (
        errObj?.extensions?.code ===
        AnswerJoinPathAmbiguityErrorType.JoinPathResolutionRequired
    );
};

export const mapJoinPathAmbiguityErrorCode = (error: ApolloError) => {
    const originalErr = (error?.networkError as any)?.result?.errors?.[0];
    if (originalErr && originalErr?.extensions?.code) {
        originalErr.extensions.code =
            AnswerErrorTypeToMsgCodeMappings[
                AnswerJoinPathAmbiguityErrorType.JoinPathResolutionRequired
            ];
    }
};

export const hasPrivilegeDataErrorInViz = (errorCode: string) => {
    return errorCode === PRIVILEGE_DATA_ERROR_CODE;
};

export const hasAccessRestrictedErrorInViz = (errorCode: string) => {
    return COLUMN_LEVEL_ACCESS_RESTRICTED_ERROR_CODE === errorCode;
};
